import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Landmark } from "lucide-react";
import { money } from "@/lib/api";
import { useMeta } from "@/hooks/useMeta";

const KEY = "sc_bank_order";

export default function BankTransferPlaced() {
  const { state } = useLocation() as any;
  const [d] = useState<any>(() => state || JSON.parse(sessionStorage.getItem(KEY) || "null"));
  useMeta("Order placed | Somnio.Co");
  useEffect(() => { if (state) sessionStorage.setItem(KEY, JSON.stringify(state)); }, [state]);
  if (!d) return (
    <div className="max-w-xl mx-auto text-center py-32 px-5" data-testid="bank-placed-missing">
      <p className="font-display text-3xl">Your bank transfer details were emailed to you</p>
      <Link to="/track" className="btn-ink inline-block mt-8 px-9 py-4 text-xs tracking-[0.25em] uppercase">Track an order</Link>
    </div>
  );
  return (
    <div className="max-w-2xl mx-auto px-5 py-20 md:py-28" data-testid="bank-placed-page">
      <Landmark size={36} strokeWidth={1} className="mx-auto" />
      <p className="eyebrow text-center mt-6">Order {d.order_number} reserved</p>
      <h1 className="font-display text-4xl sm:text-5xl text-center mt-4">Complete your bank transfer</h1>
      <p className="text-center text-sm text-neutral-600 mt-6 max-w-lg mx-auto">Please transfer the amount below using your order number as the reference. We've also emailed these details to {d.email}. We'll confirm by email as soon as your payment arrives — usually within 1–2 business days.</p>
      <dl className="mt-10 border border-neutral-900 bg-white divide-y divide-neutral-200" data-testid="bank-details">
        {d.details.map((x: any) => <Row key={x.label} label={x.label} value={x.value} />)}
        <Row label="Reference" value={d.reference} strong testId="bank-reference" />
        <Row label="Amount" value={money(d.total)} strong testId="bank-amount" />
      </dl>
      {d.notes && <p className="text-xs text-neutral-600 mt-4" data-testid="bank-notes">{d.notes}</p>}
      <div className="mt-10 flex flex-wrap justify-center gap-4">
        <Link to={`/track?order=${d.order_number}`} className="btn-ink px-9 py-4 text-xs tracking-[0.25em] uppercase" data-testid="bank-track-link">Track this order</Link>
        <Link to="/collections/all" className="btn-line px-9 py-4 text-xs tracking-[0.25em] uppercase">Continue shopping</Link>
      </div>
    </div>
  );
}

const Row = ({ label, value, strong, testId }: any) => (
  <div className="flex justify-between gap-6 px-6 py-4 text-sm" data-testid={testId}>
    <dt className="text-neutral-500">{label}</dt>
    <dd className={`text-right select-all ${strong ? "font-display text-xl" : ""}`}>{value}</dd>
  </div>
);
